<form [formGroup]="updatePrivacyForm" class="flex flex-col gap-2 text-sm">
    <div class="flex flex-col gap-1">
        <p class="font-bold">Visibility</p>
        <div class="flex flex-col gap-2">
            <div class="flex flex-row items-center gap-2">
                <div class="w-[12ch] text-right">
                    Profile
                </div>
                <select formControlName="profile" class="w-[24ch] p-1 bg-slate-100 rounded-sm shadow-sm disabled:text-slate-400">
                    @for (visibilityType of visibilityTypes ; track visibilityType[0]) {
                        <option value="{{ visibilityType[0] }}">{{ visibilityType[1] }}</option>
                    }
                </select>
            </div>
            <div class="flex flex-row items-center gap-2">
                <div class="w-[12ch] text-right">
                    Collection
                </div>
                <select formControlName="collection" class="w-[24ch] p-1 bg-slate-100 rounded-sm shadow-sm disabled:text-slate-400">
                    @for (visibilityType of visibilityTypes ; track visibilityType[0]) {
                        <option value="{{ visibilityType[0] }}">{{ visibilityType[1] }}</option>
                    }
                </select>
            </div>
            <div class="flex flex-row items-center gap-2">
                <div class="w-[12ch] text-right">
                    Decks
                </div>
                <select formControlName="decks" class="w-[24ch] p-1 bg-slate-100 rounded-sm shadow-sm disabled:text-slate-400">
                    @for (visibilityType of visibilityTypes ; track visibilityType[0]) {
                        <option value="{{ visibilityType[0] }}">{{ visibilityType[1] }}</option>
                    }
                </select>
            </div>
            <div class="flex flex-row items-center gap-2">
                <div class="w-[12ch] text-right">
                    Stats
                </div>
                <select formControlName="stats" class="w-[24ch] p-1 bg-slate-100 rounded-sm shadow-sm disabled:text-slate-400">
                    @for (visibilityType of visibilityTypes ; track visibilityType[0]) {
                        <option value="{{ visibilityType[0] }}">{{ visibilityType[1] }}</option>
                    }
                </select>
            </div>
        </div>
        <div class="flex flex-col gap-1 pt-2">
            <p class="font-bold">User Contact</p>
            <div class="flex flex-row gap-2 pl-4">
                <input formControlName="friendRequests" type="checkbox" class="p-1 border-0">
                <div>Receive friend requests.</div>
            </div>
            <p class="text-xs text-slate-400">
                If disabled, you can still send friend requests.
            </p>
        </div>
        <div class="flex justify-end">
            <button (click)="onSavePrivacySettingsClicked()" class="w-[8ch] p-1 bg-slate-100 rounded-sm shadow-sm hover:text-ponder-link hover:stroke-ponder-link hover:cursor-pointer border border-transparent hover:border-ponder-link disabled:text-slate-500 disabled:hover:text-slate-500 disabled:hover:cursor-default disabled:hover:border-transparent" [disabled]="!canSubmitPrivacyChanges()">
                @if (!isUpdatingPrivacy) {
                    @if (updateSuccess) {
                        <svg-icon [svgIcon]="checkSvgIcon" [small]="true" class="fill-none stroke-green-700"></svg-icon>
                    } @else {
                        Save
                    }
                } @else {
                    <busy-spin [small]="true"></busy-spin>
                }
            </button>
        </div>
    </div>
</form>